/** @type {import('./index').NetworkConfig} */
const linkedin = {
  name: 'LinkedIn',
  sort: 5,
  baseUrl: 'https://www.linkedin.com/in/',
  domains: ['linkedin.com', 'lnkd.in'],
  supported: true,
  color: '#0A66C2',
  hasVideoContent: false,
  supportsEmbed: false,
  // LinkedIn shows its login wall to profile visits that arrive with no `Referer`
  // header, so profile links must keep the referrer (i.e. not use `noreferrer`).
  requiresReferrer: true,
  // Personal profiles only (/in/{vanity}); company/other routes are rejected.
  // Optional non-capturing subdomain accepts country/locale hosts (www., ca., uk., ...);
  // the handle must remain capture group 1 for matchProfileUrl.
  profileUrlPattern: /^https:\/\/(?:[a-z0-9-]+\.)?linkedin\.com\/in\/([a-zA-Z0-9_-]+)\/?$/i,
};

export default linkedin;
